import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { TAdFoxBannerProps } from '@cian/adfox-component';
import * as R from 'ramda';
import * as React from 'react';

import { IDailyRentOfferForMobileSite } from '../../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { IPuids } from '../../../../common/repositories/dailyrent/entities/puids/Puids';
import { AdfoxBanner } from '../AdfoxBanner';
import { useListingBanner } from '../useListingBanner';

export interface IAdfoxListingBannerProps
  extends Omit<
    TAdFoxBannerProps,
    'ownerId' | 'onLoad' | 'onStub' | 'onError' | 'width' | 'height' | 'minWidth' | 'minHeight' | 'lazyLoad'
  > {
  offer: IDailyRentOfferForMobileSite;
  bannerType?: 'tgb' | 'parallax';
  position?: number;
}

export const AdfoxListingBanner: React.FC<IAdfoxListingBannerProps> = ({
  offer,
  position,
  bannerType,
  ...sharedProps
}) => {
  const { isHidden, onClick, onError, onView, onLoad, onStub } = useListingBanner({
    bannerType,
    position,
  });

  const offerPuidsRaw = R.pickBy(Boolean, offer.puids) as IPuids;
  // вынуждены все значения puid перевести в string
  const offerPuids = Object.keys(offerPuidsRaw).reduce<{ [key: string]: string }>((acc, puidKey: keyof IPuids) => {
    acc[puidKey] = String(offerPuidsRaw[puidKey]);

    return acc;
  }, {});

  const sharedParams = sharedProps.params;

  if (isHidden) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={onView} percentVisible={0.5} triggerOnce>
      <div onClick={onClick}>
        <AdfoxBanner
          {...sharedProps}
          ownerId={202100}
          params={{ ...offerPuids, ...sharedParams }}
          width="100%"
          minHeight="285px"
          lazyLoad={{ fetchMargin: 100, mobileScaling: 1 }}
          onLoad={onLoad}
          onStub={onStub}
          onError={onError}
        />
      </div>
    </ActionAfterViewObserver>
  );
};
